import { MouseEventType } from 'apps/webcomponents/src/utils/events';

export class DraggableElement {
  private ghostDragImage: HTMLElement | null;

  constructor(public element: HTMLElement, private dragClass: string = 'drag') {
    element.setAttribute('draggable', 'true');
  }

  public withDragStart(format: string, getData: () => string): DraggableElement {
    this.element.addEventListener(MouseEventType.DRAG_START, event => {
      event.stopPropagation();
      event.dataTransfer!.setData(format, getData());
      this.element.classList.add(this.dragClass);
      this.createGhostDragImage(event);
    });

    return this;
  }

  public withDragEnd(): DraggableElement {
    this.element.addEventListener(MouseEventType.DRAG_END, event => {
      event.stopPropagation();
      this.element.classList.remove(this.dragClass);
      this.removeGhostDragImage();
    });

    return this;
  }

  private createGhostDragImage(event: DragEvent) {
    this.ghostDragImage = document.createElement('canvas');
    this.ghostDragImage.style.position = 'absolute';
    document.body.appendChild(this.ghostDragImage);
    event.dataTransfer!.setDragImage(this.ghostDragImage, 0, 0);
  }

  private removeGhostDragImage() {
    if (!this.ghostDragImage) {
      return;
    }
    document.body.removeChild(this.ghostDragImage);
    this.ghostDragImage = null;
  }
}

export class DroppableElement {
  constructor(public element: HTMLElement) {}

  public withDragOver(): DroppableElement {
    this.element.addEventListener(MouseEventType.DRAG_OVER, event => {
      event.preventDefault();
      event.dataTransfer!.dropEffect = 'move';
    });

    return this;
  }

  public withDrop(dropHandler: Function, errorHandler?: Function): DroppableElement {
    this.element.addEventListener(MouseEventType.DROP, async event => {
      event.preventDefault();
      event.stopPropagation();

      try {
        await dropHandler(event);
      } catch (e) {
        errorHandler && errorHandler(e);
      }
    });

    return this;
  }
}
